export default function Footer() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500">
                <i className="ri-movie-2-line text-foreground-950 text-base"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                天堂影院
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              天堂影院提供高清电影在线看，汇聚最新电影、电影大全，高清不缓冲流畅在线观看，极速播放无广告，为您带来极致观影体验。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#index" onClick={(e) => scrollToSection(e, '#index')} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">电影大全</a>
              <a href="#ranking" onClick={(e) => scrollToSection(e, '#ranking')} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热度榜单</a>
              <a href="#topics" onClick={(e) => scrollToSection(e, '#topics')} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#media" onClick={(e) => scrollToSection(e, '#media')} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">精彩预告</a>
              <a href="#faq" onClick={(e) => scrollToSection(e, '#faq')} className="text-sm text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              电影分类
            </h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-400 whitespace-nowrap">动作片</span>
              <span className="text-sm text-foreground-400 whitespace-nowrap">喜剧片</span>
              <span className="text-sm text-foreground-400 whitespace-nowrap">科幻片</span>
              <span className="text-sm text-foreground-400 whitespace-nowrap">悬疑片</span>
              <span className="text-sm text-foreground-400 whitespace-nowrap">动画片</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              合作伙伴
            </h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-400">敬请期待</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/40 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-300">
            &copy; {new Date().getFullYear()} 天堂影院 · 高清电影在线看，极速播放无广告
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-300 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">服务条款</span>
            <span className="text-xs text-foreground-300 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-300 cursor-pointer hover:text-foreground-500 transition-colors whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}